var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98002 1.07C7.00835 1.38167 7.17835 1.55167 7.49002 1.58H9.65752L4.91877 6.31875C4.72044 6.55959 4.72044 6.80042 4.91877 7.04125C5.1596 7.23959 5.40044 7.23959 5.64127 7.04125L10.38 2.3025V4.47C10.4084 4.78167 10.5784 4.95167 10.89 4.98C11.2017 4.95167 11.3717 4.78167 11.4 4.47V1.07C11.3717 0.758336 11.2017 0.588336 10.89 0.560002H7.49002C7.17835 0.588336 7.00835 0.758336 6.98002 1.07ZM2.05002 1.24C1.61085 1.25417 1.2496 1.40292 0.96627 1.68625C0.682936 1.96959 0.534186 2.33084 0.52002 2.77V9.91C0.534186 10.3492 0.682936 10.7104 0.96627 10.9938C1.2496 11.2771 1.61085 11.4258 2.05002 11.44H9.19002C9.62919 11.4258 9.99044 11.2771 10.2738 10.9938C10.5571 10.7104 10.7059 10.3492 10.72 9.91V7.19C10.6917 6.87834 10.5217 6.70834 10.21 6.68C9.89835 6.70834 9.72835 6.87834 9.70002 7.19V9.91C9.67169 10.2217 9.50169 10.3917 9.19002 10.42H2.05002C1.73835 10.3917 1.56835 10.2217 1.54002 9.91V2.77C1.56835 2.45834 1.73835 2.28834 2.05002 2.26H4.77002C5.08169 2.23167 5.25169 2.06167 5.28002 1.75C5.25169 1.43834 5.08169 1.26834 4.77002 1.24H2.05002Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.88,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.52002 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.bb39c720bb64f50391a3695d23646863.svg";
export { ForwardRef as ReactComponent };